import { Box, Button, Typography } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import {
  FreeTokenAvailable,
  selectFreeVideo,
  writeVideoStatistic,
} from '../../../api/video';
import { useAuth } from '../../../contexts/auth';
import { useMenuContext } from '../../../contexts/menuContextProvider';
import { useNotification } from '../../../contexts/notification';
const VideoItem = ({
  videoKey,
  videoURL,
  videoTitle,
  videoText,
  accessNeeded,
  freeVideo,
  onReloadRequest,
}) => {
  const [userHasNeededSubscription, setUserHasNeededSubscription] =
    useState(false);
  const [playbackState, setPlaybackStatus] = useState({
    url: videoURL,
    userId: null,
    playId: '',
    videoKey: videoKey,
    playing: false,
    duration: 0,
  });
  const { setNotification } = useNotification();
  const { user } = useAuth();
  const { menuContext } = useMenuContext();

  useLayoutEffect(() => {
    if (user && user.activeSubscriptions) {
      const hasAccess = user.activeSubscriptions.some((sub) =>
        accessNeeded.includes(sub)
      );
      setUserHasNeededSubscription(hasAccess);
    }
  }, [menuContext, user, accessNeeded]);

  useEffect(() => {
    if (user) {
      setPlaybackStatus((prevState) => ({
        ...prevState,
        userId: user.userData.user.id,
        playId: `${user.userData.user.id}_${moment().format('YYYYMMDDHHMMSS')}`,
      }));
    }
  }, [user]);

  useEffect(() => {
    if (playbackState.playing) {
      try {
        writeVideoStatistic(playbackState);
      } catch (err) {
        console.error('Hiba a videó statisztikában:', err);
      }
    }
  }, [playbackState.playing]);

  const handleProgress = (state) => {
    if (playbackState.playing) {
      setPlaybackStatus((prevState) => ({ ...prevState, ...state }));
      writeVideoStatistic(playbackState);
    }
  };

  const handlePlay = () => {
    setPlaybackStatus((prevState) => ({ ...prevState, playing: true }));
  };

  const handlePause = () => {
    setPlaybackStatus((prevState) => ({ ...prevState, playing: false }));
  };

  const handleDuration = (duration) => {
    setPlaybackStatus((prevState) => ({ ...prevState, duration }));
  };

  const handleEnded = () => {
    setPlaybackStatus((prevState) => ({ ...prevState, playing: false }));
  };

  const handleSelectVideo = () => {
    const selectedVideo = {
      userId: user.userData.user.id,
      videoId: videoKey,
      user_subscripition_id: user.activeSubscriptionValues[0].id,
      selectionDate: moment().format('YYYY-MM-DD'),
      year: moment().format('YYYY'),
      week: moment().format('WW'),
      expireDate: user.activeSubscriptionValues[0].valid_to,
    };
    FreeTokenAvailable().then((available) => {
      if (available) {
        selectFreeVideo(selectedVideo);
      } else {
        setNotification({
          open: true,
          message:
            'A héten már elhasználtad az ingyenes videó lehetőségedet, gyere vissza jövő héten újra!',
          severity: 'error',
        });
      }
    });
    onReloadRequest();
  };

  return (
    <Box
      elevation={3}
      variant='outlined'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: 'primary.light',
        minWidth: 200,
        width: '100%',
        padding: 2,
        margin: '5px 5px 5px 5px',
        border: '1px solid #ccc',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.3)',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'scale(1.03)',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
        },
      }}
    >
      <Typography
        variant='h6'
        sx={{
          textAlign: 'center',
          marginBottom: 2,
          fontWeight: 600,
        }}
      >
        {videoTitle}
      </Typography>
      {!(userHasNeededSubscription || freeVideo === true) && (
        <Button
          variant='special'
          onClick={() => {
            handleSelectVideo();
          }}
          fullWidth
          sx={{ maxWidth: 400, height: 50, typography: 'h4' }}
        >
          <Typography
            variant='h6'
            sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
          >
            Heti videó választása
          </Typography>
        </Button>
      )}
      <Typography
        variant='body1'
        sx={{
          marginBottom: 2,
          textAlign: 'justify',
          fontSize: '1rem',
          maxWidth: '95%',
        }}
      >
        {videoText}
      </Typography>
      <Box
        sx={{
          width: '100%',
          position: 'relative',
          paddingTop: '56.25%', // 16:9 aspect ratio
        }}
      >
        <ReactPlayer
          key={videoKey}
          width='100%'
          height='100%'
          url={videoURL}
          //light={true}
          controls={userHasNeededSubscription || freeVideo === true}
          onProgress={handleProgress}
          progressInterval={5000}
          onPlay={handlePlay}
          onPause={handlePause}
          onDuration={handleDuration}
          onEnded={handleEnded}
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
      </Box>
    </Box>
  );
};

export default VideoItem;
